<template>
  <div class="mv">
    <div>
      <img
        src="@/assets/images/events/logo_top.png"
        alt="マイナビレジデントフェスティバル"
      />
      <p>
        医学生・初期研修医のための<br
          class="hiddenPc"
        />合同臨床研修プログラム説明会
      </p>
    </div>
  </div>

  <div class="ad ad01" v-if="adBanners[0]">
    <AdBanner :item="adBanners[0]" />
  </div>

  <div class="lead u-containar">
    <p>
      イベントに参加すると、医師、研修医、病院担当者に<br
        class="hiddenSp"
      />直接話を聞くことができます。<br />
      会場での対面型とオンラインの開催がありますので、<br class="hiddenSp" />
      ご都合にあわせてお気軽に参加ください。<br />
      自分に合った研修病院に出会いましょう！
    </p>
    <dl class="checklist">
      <dt>こんな人におすすめ</dt>
      <dd>
        <ul class="checklist_items">
          <li>研修医に実際の生活の様子が聞ける！</li>
          <li>病院見学のポイントを知ることができる！</li>
          <li>病院選びを考えるきっかけが作れる！</li>
        </ul>
      </dd>
    </dl>
  </div>

  <HeadingLv1 disableMargin text="LIVEイベント・セミナー日程一覧" />

  <LocalNav v-if="navList.length" :list="navList" showPc :offset="0" />

  <div class="u-containar hiddenPc">
    <ArchiveBanner class="archiveBannerTop" />
  </div>

  <div class="u-containar column2">
    <div class="main">
      <div v-if="navList.length">
        <div class="inputFlex">
          <InputSelectbox
            :options="filterTypes"
            class="selector"
            @selection-change="selectFilterType"
          />
          <InputSelectbox
            :options="categories"
            class="selector"
            @selection-change="filterCategory"
          />
        </div>
        <div class="eventContainer">
          <section
            :id="date"
            v-for="(events, date) in eventsByMonth"
            :key="date"
          >
            <HeadingLv3
              :text="`${Number(date.slice(-2))}月開催のイベント`"
              class="title"
            />
            <div class="card-wrapper" v-if="events.length">
              <EventCardActive
                v-for="(event, i) in events"
                :key="i"
                :event="event"
              />
            </div>
            <p v-else class="noEvents">
              当月での開催の予定はございません。
            </p>
          </section>
        </div>
      </div>
      <div class="innerBanner">
        <ArchiveBanner class="archiveBanner" />

        <div class="ad ad2" v-if="adBanners[1]">
          <AdBanner :item="adBanners[1]" />
        </div>
      </div>

      <section class="section">
        <EventPresent />
      </section>

      <section class="section">
        <HeadingLv2 text="よくある質問" icon="question" />
        <div v-if="faqs.length" class="accordion">
          <FaqLists
            v-for="faq in faqs"
            :key="faq.id"
            :list="faq"
            :isEvents="true"
          />
        </div>
        <Alert v-else text="ただいま質問は存在しません。" />
        <Button label="よくある質問一覧へ" :handleClick="toFaq" primary />
      </section>
    </div>

    <div class="side">
      <div class="sideInner">
        <ArchiveBanner isSide class="archiveBannerSide hiddenSp" />
        <EventFooter />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, ref, defineComponent, reactive } from 'vue'
import { useRouter } from 'vue-router'
import ArchiveBanner from '@/components/block/ArchiveBanner.vue'
import EventFooter from '@/components/block/EventFooter.vue'
import EventPresent from '@/components/block/EventPresent.vue'
import Button from '@/components/elements/Button.vue'
import FaqLists from '@/components/block/FaqLists.vue'
import Alert from '@/components/elements/Alert.vue'
import AdBanner, { AdBannerType } from '@/components/block/AdBanner.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import InputSelectbox from '@/components/elements/InputSelectbox.vue'
import EventCardActive from '@/components/block/EventCardActive.vue'
import LocalNav from '@/components/block/LocalNav.vue'

import { useEvent } from '@/provider/event'
import { mapValues, omitBy } from 'lodash-es'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')
export default defineComponent({
  name: 'EventsList',
  components: {
    HeadingLv2,
    ArchiveBanner,
    EventPresent,
    EventFooter,
    Button,
    FaqLists,
    Alert,
    AdBanner,
    HeadingLv1,
    HeadingLv3,
    EventCardActive,
    LocalNav,
    InputSelectbox
  },
  setup() {
    const router = useRouter()
    const ajax = axiosSetting('cms', 'block')

    const {
      getEvents,
      eventsByMonth: eventsByMonthBase,
      createCategories,
      createFilterType
    } = useEvent()
    getEvents()

    const filteredCategory = ref<any>(undefined)
    const filterCategory = (value: string) => {
      console.log(value)
      filteredCategory.value = value
    }
    const selectedFilterType = ref<any>(undefined)
    const selectFilterType = (val: string | null | undefined) => {
      selectedFilterType.value = val
    }
    const eventsByMonth = computed(() =>
      omitBy(
        mapValues(eventsByMonthBase.value, (events) =>
          events.filter((event: any) => {
            if (
              filteredCategory.value &&
              event.category?.slug !== filteredCategory.value
            ) {
              return false
            }
            if (selectedFilterType.value && !event.filter_type.length) {
              return false
            }
            if (
              selectedFilterType.value &&
              event.filter_type.every(
                (type: any) => type.value !== selectedFilterType.value
              )
            ) {
              return false
            }
            return true
          })
        ),
        (events: any) => !events.length
      )
    )

    const navList = computed(() =>
      Object.keys(eventsByMonth.value).map((YYYYMM) => ({
        id: YYYYMM,
        label: dayjs(`${YYYYMM}01`).format('YYYY年M月')
      }))
    )
    const categories = computed(() =>
      createCategories(Object.values(eventsByMonthBase.value).flat())
    )
    const filterTypes = computed(() =>
      createFilterType(Object.values(eventsByMonthBase.value).flat())
    )

    // FAQ
    const toFaq = () => {
      router.push({ path: '/faq' })
    }
    const faqs = ref([])
    const getFaqs = () => {
      ajax
        .get(
          `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/faq?category=events&per_page=5`
        )
        .then((res) => {
          faqs.value = res.data
        })
    }
    getFaqs()

    // 有料バナー表示病院を取得
    const adBanners = reactive<AdBannerType[]>([])
    const ajaxApp = axiosSetting('app', 'block')

    ajaxApp.get('/api/v1/banner?opt_id=4').then((res) => {
      if (res.data.length === 0) return

      const ads = res.data
      let count = 0
      const indexArr: Array<number> = []
      const maxCount = ads.length < 2 ? ads.length : 2

      while (count < maxCount) {
        const randomIndex: number = Math.floor(Math.random() * ads.length)

        if (!indexArr.includes(randomIndex)) {
          indexArr.push(randomIndex)
          count++
        }
      }
      for (let i = 0; i < indexArr.length; i++) {
        adBanners.push(ads[indexArr[i]])
      }
    })

    return {
      toFaq,
      faqs,
      adBanners,
      eventsByMonth,
      navList,
      categories,
      filterCategory,
      filterTypes,
      selectFilterType
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.section + .section {
  margin-top: 45px;
  @include mixins.media() {
    margin-top: 96px;
  }
}

.headingLv2 + p {
  margin-top: 12px;
  margin-bottom: 12px;
}

.mv {
  background: url('~@/assets/images/events/bg_top.jpg') no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  padding: 0 30px;
  height: 200px;
  background-color: #eee;
  font-size: 1.3rem;
  margin-bottom: 18px;
  @include mixins.media() {
    background-image: url('~@/assets/images/events/pc-bg_top.jpg');
    font-size: 1.4rem;
    height: 240px;
    margin-bottom: 24px;
  }

  @include mixins.media() {
    div {
      width: 100%;
      max-width: 1088px;
      margin: 0 auto;
    }
  }

  img {
    width: 171px;
    height: auto;
    margin-bottom: 16px;
    @include mixins.media() {
      width: 271px;
    }
  }

  p {
    padding: 0 15px;
    background: #ffe869;
    background: -moz-linear-gradient(left, #ffe869 0%, #caf58f 100%);
    background: -webkit-linear-gradient(left, #ffe869 0%, #caf58f 100%);
    background: linear-gradient(to right, #ffe869 0%, #caf58f 100%);
    @include mixins.media() {
      display: table;
      padding: 0 19px;
    }
  }
}
.lead {
  margin-bottom: 40px;
}
@include mixins.media() {
  .lead {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 48px;
    p {
      text-align: center;
      margin: 0 40px;
    }
  }
}

.checklist {
  position: relative;
  margin-top: 43px;
  padding: 0 16px 20px;
  background-color: var.$color-secondary;
  @include mixins.media() {
    width: 524px;
  }
  > dt {
    font-weight: 500;
    line-height: 1;

    &::before {
      display: inline-block;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      transform: translateY(-20px);
      width: 153px;
      height: 20px;
      background-color: var.$color-secondary;
    }

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      content: '';
      transform: translate(153px, -20px);
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 20px 0 0 20px;
      border-color: transparent transparent transparent var.$color-secondary;
    }
  }

  > dd {
    margin-top: 6px;
  }
}

.checklist_items {
  > li {
    text-indent: -1.4em;
    margin-left: 1.4em;

    &::before {
      display: inline-block;
      content: '';
      width: 12px;
      height: 8px;
      margin-right: 8px;
      border-left: 2px solid var.$color-main;
      border-bottom: 2px solid var.$color-main;
      transform: rotate(-45deg);
      vertical-align: 2px;
      @include mixins.media() {
        margin-right: 31px;
      }
    }
  }
}

.accordion {
  + .button {
    margin-top: 32px;
  }
}
.ad {
  padding-left: 16px;
  padding-right: 16px;
  @include mixins.media() {
    padding-left: 0;
    padding-right: 0;
    ::v-deep .adBanner {
      padding: 0;
      max-width: 806px;
    }
  }
}
.ad01 {
  margin-top: 32px;
  margin-bottom: 32px;
  @include mixins.media() {
    margin-top: 48px;
    margin-bottom: 24px;
  }
}
.innerBanner {
  padding-top: 32px;
  padding-bottom: 48px;
  @include mixins.media() {
    padding-top: 40px;
    padding-bottom: 96px;
  }
}
.ad2 {
  margin-top: 32px;
  @include mixins.media() {
    margin-top: 40px;
  }
}
.column2 {
  display: grid;
  gap: 48px;
  @include mixins.media() {
    padding-top: 40px;
    grid-template-columns: 1fr 242px;
    gap: 30px;
  }
}
.noEvents {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var.$color-secondary;
  height: 190px;
  border-radius: 5px;
  @include mixins.media() {
    height: 300px;
  }
}
.title {
  margin-bottom: 20px;
}
section + section {
  margin-top: 50px;
}
.eventContainer {
  padding-top: 16px;
  padding-bottom: 60px;
  border-bottom: solid 0.5px var.$color-border-gray;
  @include mixins.media() {
    padding-top: 24px;
  }
}
.archiveBannerTop {
  margin-top: 32px;
  margin-bottom: 32px;
  @include mixins.media() {
    margin-top: 0;
    margin-bottom: 24px;
  }
}
.archiveBannerSide {
  @include mixins.media() {
    margin-bottom: 24px;
  }
}
.card-wrapper {
  display: grid;
  gap: 30px;
  @include mixins.media() {
    grid-template-columns: 1fr 1fr;
  }
}
.inputFlex {
  display: flex;
  justify-content: flex-end;
  .selector {
    max-width: 140px;
    margin-left: 0;
    &:first-child {
      margin-right: 20px;
    }
  }
}
.side {
  @include mixins.media() {
    position: relative;
  }
}
.sideInner {
  @include mixins.media() {
    position: sticky;
    right: 0;
    top: 0;
  }
}
</style>
